import { Component, EventEmitter, HostListener, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IActivityLog, ICameraGroupPauseChangeRecord } from 'app/models/activity-log.model';
import { IdentityFormatPipe, MomentPipe } from 'app/pipes/pipes';
import { AnchorWrapPipe, EscapeHtmlPipe, StrongWrapPipe } from '../activity-log-table/activity-log-table-pipes';

@Component({
    selector: 'app-activity-camera-pause-details',
    imports: [CommonModule, TranslateModule, RouterModule, MomentPipe, IdentityFormatPipe, AnchorWrapPipe, StrongWrapPipe, EscapeHtmlPipe],
    templateUrl: './activity-camera-pause-details.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['../activity-details-dialog/activity-details-content-styles.css']
})
export class ActivityCameraPauseDetailsComponent implements OnChanges {
  @Output() closeDialog = new EventEmitter<void>();
  @Input() log: IActivityLog;

  pauseChanges: ICameraGroupPauseChangeRecord;

  constructor(private router: Router) {}

  @HostListener('document:click', ['$event'])
  onLinkClick(event: MouseEvent): void {
    const anchor = (event.target as HTMLElement).closest('a.link');
    if (!anchor) return;
    event.preventDefault();
    const url = anchor.getAttribute('data-url');
    if (url) this.router.navigateByUrl(url);
    this.closeDialog.emit();
  }

  ngOnChanges(): void {
    this.pauseChanges = this.log?.details?.cameraGroupPauseChanges;
  }
}
